import { CoverageIdEnum } from 'outshared-lib';
import { CoverageTableConfigInterface } from '../interfaces';

export const coverageBicycleData: CoverageTableConfigInterface = {
    descriptions: [
        { label: '(Poging tot) diefstal' },
        { label: 'Accessoires, slot en accu verzekerd' },
        { label: 'Eigen risico' },
        { label: 'Schade aan uw fiets door een ongeluk' },
        { label: 'Schade aan uw fiets door omvallen of omwaaien' },
    ],
    items: [
        {
            id: CoverageIdEnum.BicycleTheft,
            title: 'Diefstal',
            subtitle: null,
            note: null,
            noteSmall: null,
            options: [
                {
                    type: 'boolean',
                    value: true,
                },
                {
                    type: 'boolean',
                    value: true,
                },
                {
                    type: 'string',
                    value: '€ 0',
                },
                {
                    type: 'boolean',
                    value: false,
                },
                {
                    type: 'boolean',
                    value: false,
                },
            ],
        },
        {
            id: CoverageIdEnum.BicycleAllrisk,
            title: 'Allrisk',
            subtitle: null,
            note: null,
            noteSmall: null,
            options: [
                {
                    type: 'boolean',
                    value: true,
                },
                {
                    type: 'boolean',
                    value: true,
                },
                {
                    type: 'string',
                    value: '€ 0',
                },
                {
                    type: 'boolean',
                    value: true,
                },
                {
                    type: 'boolean',
                    value: true,
                },
            ],
        },
    ],
    rows: [],
};
